import { Percentage } from '@sparkdotfi/common-universal'

import approve from './actions/approve.svg'
import borrow from './actions/borrow.svg'
import deposit from './actions/deposit.svg'
import done from './actions/done.svg'
import exchange from './actions/exchange.svg'
import repay from './actions/repay.svg'
import withdraw from './actions/withdraw.svg'
import arrowRight from './arrow-right.svg'
import mkrToSkyTransform from './banners/mkr-to-sky-transform.svg'
import boxArrowTopRight from './box-arrow-top-right.svg'
import logoDark from './brand/logo-dark.svg'
import logoGradientDark from './brand/logo-gradient-dark.svg'
import logoGradientLight from './brand/logo-gradient-light.svg'
import logoLight from './brand/logo-light.svg'
import sparkLiquidityLayer from './brand/spark-liquidity-layer.svg'
import symbolDark from './brand/symbol-dark.svg'
import symbolGradient from './brand/symbol-gradient.svg'
import symboLight from './brand/symbol-light.svg'
import arbitrum from './chains/arbitrum.svg'
import avalanche from './chains/avalanche.svg'
import base from './chains/base.svg'
import ethereum from './chains/ethereum.svg'
import gnosis from './chains/gnosis.svg'
import optimism from './chains/optimism.svg'
import unichain from './chains/unichain.svg'
import checkCircle from './check-circle.svg'
import chevronDown from './chevron-down.svg'
import circleInfo from './circle-info.svg'
import close from './close.svg'
import closeFilled from './close-filled.svg'
import cowSwap from './cow-swap.svg'
import down from './down.svg'
import downgrade from './downgrade.svg'
import equal from './equal.svg'
import eye from './eye.svg'
import flash from './flash.svg'
import giftGradient from './gift-gradient.svg'
import giftbox from './giftbox.svg'
import neoNodeAvatar from './governance/neo-node-avatar.svg'
import participateInDaoImagery from './governance/participate-in-dao-imagery.svg'
import remiAvatar from './governance/remi-avatar.svg'
import theMoonAvatar from './governance/the-moon-avatar.svg'
import unknownDelegateAvatar from './governance/unknown-delegate-avatar.svg'
import votingPowerIcon from './governance/voting-power-icon.svg'
import governanceWelcomeDialogBg from './governance/welcome-dialog-bg.svg'
import greenArrowUp from './green-arrow-up.svg'
import handCoins from './hand-coins.svg'
import lightningVioletCircle from './icons/lightning-violet-circle.svg'
import bitget from './integrators/bitget.svg'
import imtoken from './integrators/imtoken.svg'
import nansen from './integrators/nansen.svg'
import lifiLogo from './lifi-logo.svg'
import link from './link.svg'
import magicWand from './magic-wand.svg'
import magicWandCircle from './magic-wand-circle.svg'
import makerLogo from './maker.svg'
import usdcUsdsIntersectIcon from './marketDetails/usdc-usds-intersect-icon.svg'
import chart from './markets/chart.svg'
import inputOutput from './markets/input-output.svg'
import lock from './markets/lock.svg'
import output from './markets/output.svg'
import usdcViaUsdsProxyMarketIcon from './markets/usdc-via-usds.svg'
import menu from './menu.svg'
import moreIcon from './more-icon.svg'
import moreIconVertical from './more-icon-vertical.svg'
import multiply from './multiply.svg'
import chainlink from './oracle-providers/chainlink.svg'
import chronicle from './oracle-providers/chronicle.svg'
import lido from './oracle-providers/lido.svg'
import redstoneOracle from './oracle-providers/redstone.svg'
import farmsIcon from './page/farms-icon.svg'
import farmsCircleIcon from './page/farms-icon-circle.svg'
import savingsIcon from './page/savings-icon.svg'
import savingsCircleIcon from './page/savings-icon-circle.svg'
import sparkRewardsIcon from './page/spark-rewards-icon.svg'
import sparkRewardsCircleIcon from './page/spark-rewards-icon-circle.svg'
import sparkLendIcon from './page/sparklend-icon.svg'
import sparkLendCircleIcon from './page/sparklend-icon-circle.svg'
import swapIcon from './page/swap-icon.svg'
import swapIconCircle from './page/swap-icon-circle.svg'
import pause from './pause.svg'
import benmoSparklendIcon from './points/benmo-sparklend-icon.svg'
import governanceIcon from './points/governance-icon.svg'
import pointsGuestModePanelBg from './points/guest-mode-panel-bg.svg'
import holdSusdcIcon from './points/hold-susdc-icon.svg'
import inviteIcon from './points/invite-icon.svg'
import loyaltyIcon from './points/loyalty-icon.svg'
import pendleIcon from './points/pendle-icon.svg'
import pointsIcon from './points/points-icon.svg'
import pointsOnboardingBg from './points/points-onboarding-bg.svg'
import rocketGradientIcon from './points/rocket-gradient.svg'
import spkInvertedIcon from './points/spk-inverted.svg'
import pointsStakingIcon from './points/staking.svg'
import guestModePanelIcon from './rewards/guest-mode-panel-icon.svg'
import rocket from './rocket.svg'
import daiUpgrade from './savings/dai-upgrade.webp'
import savingsWelcome from './savings/savings-welcome.webp'
import sdaiUpgrade from './savings/sdai-upgrade.webp'
import sdaiUpgradeBannerIcon from './savings/sdai-upgrade-banner-icon.svg'
import stusdsWelcomeBg from './savings/stusds-welcome-bg.svg'
import susdcUpgradeBannerIcon from './savings/susdc-upgrade-banner-icon.svg'
import upgradeBannerBg from './savings/upgrade-banner-bg.svg'
import sliderThumb from './slider-thumb.svg'
import snowflake from './snowflake.svg'
import discord from './social-platforms/discord.svg'
import x from './social-platforms/x.svg'
import xNoBackground from './social-platforms/x-no-bg.svg'
import sparkIcon from './spark-icon.svg'
import sparkLiquidityLayerLogo from './spark-liquidity-layer-logo.svg'
import spkRewardsSyncingStatusIcon from './spark-staking/syncing-status-icon.svg'
import helloSpkPanelBg from './spk-airdrop/hello-spk-panel-bg.svg'
import squareImagery from './spk-airdrop/infographic/highlights/square.webp'
import susdcBoostOptionVisual from './spk-airdrop/susdc-boost-option-visual.svg'
import susdsBoostOptionVisual from './spk-airdrop/susds-boost-option-visual.svg'
import success from './success.svg'
import threeDots from './three-dots.svg'
import timer from './timer.svg'
import unknown from './unknown-token.svg'
import up from './up.svg'
import upgrade from './upgrade.svg'
import wallet from './wallet.svg'
import coinbase from './wallet-icons/coinbase.svg'
import defaultWallet from './wallet-icons/default.svg'
import enjin from './wallet-icons/enjin.svg'
import metamask from './wallet-icons/metamask.svg'
import torus from './wallet-icons/torus.svg'
import walletConnect from './wallet-icons/wallet-connect.svg'
import warning from './warning.svg'
import xCircle from './x-circle.svg'
import zap from './zap.svg'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export const assets = {
  sparkIcon,
  lifiLogo,
  chevronDown,
  sliderThumb,
  circleInfo,
  up,
  down,
  success,
  wallet,
  link,
  cowSwap,
  threeDots,
  arrowRight,
  warning,
  pause,
  snowflake,
  xCircle,
  checkCircle,
  flash,
  greenArrowUp,
  boxArrowTopRight,
  magicWand,
  magicWandCircle,
  moreIcon,
  moreIconVertical,
  eye,
  menu,
  close,
  closeFilled,
  makerLogo,
  giftbox,
  rocket,
  downgrade,
  timer,
  multiply,
  equal,
  handCoins,
  giftGradient,
  zap,
  sparkLiquidityLayerLogo,
  lightningVioletCircle,
  actions: {
    upgrade,
    downgrade,
    approve,
    done,
    borrow,
    deposit,
    withdraw,
    repay,
    exchange,
  },
  chain: {
    gnosis,
    ethereum,
    unknown,
    base,
    arbitrum,
    optimism,
    unichain,
    avalanche,
  },
  token: {
    unknown,
  },
  socialPlatforms: {
    x,
    discord,
    xNoBackground,
  },
  walletIcons: {
    coinbase,
    enjin,
    metamask,
    torus,
    walletConnect,
    default: defaultWallet,
  },
  savings: {
    sdaiUpgradeBannerIcon,
    susdcUpgradeBannerIcon,
    upgradeBannerBg,
    daiUpgrade,
    sdaiUpgrade,
    savingsWelcome,
    stusdsWelcomeBg,
  },
  markets: {
    chart,
    inputOutput,
    lock,
    output,
    usdcViaUsdsProxyMarketIcon,
  },
  marketDetails: {
    usdcUsdsIntersectIcon,
  },
  spkStaking: {
    syncingStatusIcon: spkRewardsSyncingStatusIcon,
  },
  rewards: {
    guestModePanelIcon,
  },
  spkAirdrop: {
    helloSpkPanelBg,
    susdcBoostOptionVisual,
    susdsBoostOptionVisual,
    infographic: {
      squareImagery,
    },
  },
  points: {
    onboardingBg: pointsOnboardingBg,
    rocketGradientIcon,
    pointsIcon,
    pendleIcon,
    inviteIcon,
    spkInvertedIcon,
    guestModePanelBg: pointsGuestModePanelBg,
    stakingIcon: pointsStakingIcon,
    holdSusdcIcon,
    governanceIcon,
    loyaltyIcon,
    benmoSparklendIcon,
  },
  governance: {
    governanceWelcomeDialogBg,
    votingPowerIcon,
    participateInDaoImagery,
    neoNodeAvatar,
    remiAvatar,
    theMoonAvatar,
    unknownDelegateAvatar,
  },
  banners: {
    mkrToSkyTransform,
  },
  oracleProviders: {
    chainlink,
    chronicle,
    redstone: redstoneOracle,
    lido,
  },
  page: {
    savings: savingsIcon,
    savingsCircle: savingsCircleIcon,
    farms: farmsIcon,
    farmsCircle: farmsCircleIcon,
    sparkLend: sparkLendIcon,
    sparkLendCircle: sparkLendCircleIcon,
    sparkRewards: sparkRewardsIcon,
    sparkRewardsCircle: sparkRewardsCircleIcon,
    swap: swapIcon,
    swapCircle: swapIconCircle,
  },

  brand: {
    symbolGradient,
    symbolDark,
    symboLight,
    logoDark,
    logoLight,
    logoGradientLight,
    logoGradientDark,
    sparkLiquidityLayer,
  },
  integrators: {
    bitget,
    imtoken,
    nansen,
  },
}

export function getSocialPlatformIcon(platform: string): string {
  const icon = assets.socialPlatforms[platform as keyof typeof assets.socialPlatforms]
  if (!icon) {
    return assets.token.unknown
  }
  return icon
}

export function getTokenColor(symbol: TokenSymbol, options?: { alpha?: Percentage; fallback?: string }): string {
  const color = tokenColors[symbol]
  const alpha = (options?.alpha ?? Percentage(1)).toFixed(2)
  const fallback = options?.fallback ?? `rgb(217 217 217 / ${alpha})`

  return color ? `rgb(${color} / ${alpha})` : fallback
}

const tokenColors: Record<TokenSymbol, `${number} ${number} ${number}`> = {
  [TokenSymbol('DAI')]: '255 192 70',
  [TokenSymbol('ETH')]: '124 192 255',
  [TokenSymbol('EURe')]: '0 134 194',
  [TokenSymbol('GNO')]: '62 105 87',
  [TokenSymbol('MKR')]: '26 171 155',
  [TokenSymbol('SKY')]: '178 104 252',
  [TokenSymbol('USDS')]: '255 163 76',
  [TokenSymbol('rETH')]: '255 151 125',
  [TokenSymbol('sDAI')]: '53 181 82',
  [TokenSymbol('sUSDS')]: '53 181 82',
  [TokenSymbol('stETH')]: '143 146 236',
  [TokenSymbol('USDC')]: '51 146 248',
  [TokenSymbol('sUSDC')]: '17 160 179',
  [TokenSymbol('spUSDC')]: '17 160 179',
  [TokenSymbol('spPYUSD')]: '0 113 243',
  [TokenSymbol('stUSDS')]: '37 154 193',
  [TokenSymbol('USDC.e')]: '51 146 248',
  [TokenSymbol('USDT')]: '38 161 123',
  [TokenSymbol('WBTC')]: '240 146 66',
  [TokenSymbol('weETH')]: '90 68 190',
  [TokenSymbol('WETH')]: '134 168 239',
  [TokenSymbol('wstETH')]: '0 163 255',
  [TokenSymbol('WXDAI')]: '253 177 31',
  [TokenSymbol('XDAI')]: '255 192 70',
  [TokenSymbol('CLE')]: '47 208 91',
  [TokenSymbol('cbBTC')]: '0 82 255',
  [TokenSymbol('RED')]: '174 8 34',
  [TokenSymbol('SPK')]: '358 54 99',
  [TokenSymbol('LBTC')]: '58 114 107',
  [TokenSymbol('tBTC')]: '29 34 41',
  [TokenSymbol('ezETH')]: '196 255 97',
  [TokenSymbol('rsETH')]: '7 90 90',
  [TokenSymbol('OP')]: '255 4 33',
  [TokenSymbol('PYUSD')]: '0 113 243',
  [TokenSymbol('stUSDS')]: '37 154 193',
  [TokenSymbol('WAVAX')]: '232 65 66',
}
